<button
  class=""
  pButton
  severity="help"
  icon="fas fa-question-circle"
  (click)="openHelp(key)"
  [rounded]="true"></button>
